import { useEffect } from 'react';

import { FindStatus } from '@src/types/oneTouchSwitching';
import { OTSFormValues } from '@src/types/yourDetails';
import { useTrackingContext } from '@tracking/Provider/Context';
import {
  useTrackSignupOtsBroadbandNotFoundInfoDisplayedOnce,
  useTrackSignupOtsFirstTrySuccessModalDisplayedOnce,
  useTrackSignupOtsSecondTrySuccessModalDisplayedOnce,
} from '@tracking/trackingEvents';

const useOneTouchSwitchTrackEvents = (
  {
    otsFindStatus: findStatus,
    otsAccountReference: accountReference,
  }: OTSFormValues,
  firstAttemptFailed: boolean
) => {
  const trackBroadbandNotFoundInfoDisplayed =
    useTrackSignupOtsBroadbandNotFoundInfoDisplayedOnce();

  const trackFirstTrySuccessModalDisplayed =
    useTrackSignupOtsFirstTrySuccessModalDisplayedOnce();
  const trackSecondTrySuccessModalDisplayed =
    useTrackSignupOtsSecondTrySuccessModalDisplayedOnce();

  const { trackingContexts } = useTrackingContext();
  useEffect(() => {
    // Track for success modal after the first attempt, without adding the accountReference
    if (
      !firstAttemptFailed &&
      findStatus === FindStatus.FOUND &&
      !accountReference
    ) {
      trackFirstTrySuccessModalDisplayed({}, { contexts: trackingContexts });
    }
    // Track for success modal after the second attempt, with the accountReference added
    if (
      firstAttemptFailed &&
      findStatus === FindStatus.FOUND &&
      accountReference
    ) {
      trackSecondTrySuccessModalDisplayed({}, { contexts: trackingContexts });
    }

    if (findStatus === FindStatus.FAIL) {
      trackBroadbandNotFoundInfoDisplayed({}, { contexts: trackingContexts });
    }
  }, [
    findStatus,
    accountReference,
    firstAttemptFailed,
    trackBroadbandNotFoundInfoDisplayed,
    trackFirstTrySuccessModalDisplayed,
    trackSecondTrySuccessModalDisplayed,
    trackingContexts,
  ]);
};

export { useOneTouchSwitchTrackEvents };
